// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__v34kj","arrowIcon":"DateRangeController_arrowIcon__2I4u_"};